/*
 * 
 * THE FUNCTION HERE IS NOT ADDED TO THE replace.js FILE BECAUSE IT IS CONSIDERED TO BE LONG
 * 
 * */


export const replaceLastOccuranceInString = ( charactersToBeReplaced, charactersToBeUsedAsReplacement, variableOnWhichReplacementShouldBePerformed)=>{
	
	/*
	 * THIS FUNCTION REPLACE THE LAST OCCURANCE OF A CHARACTER/S (charactersToBeReplaced) IN A STRING
	 * THE FUNCTION HAS TO BE PROVIDED WITH THE NEW SETS OF CHARACTER/S (charactersToBeUsedAsReplacement) THAT IS TO BE USED AS REPLACEMENT
	 * THE STRING ON WHICH THE REPLACEMENT IS TO BE PERFORMED (variableOnWhichReplacementShouldBePerformed) ALSO NEEDS TO BE PROVIDED
	 * 
	 * FOR EXAMPLE: REPLACE one WITH love IN "one Two, friend one gift one"
	 * ONLY THE one THAT COMES AFTER THE GIFT WILL BE REPLACED IRRESPCTIVE OF HOW MANY TIMES one APPEARS ON THE STRING
	 * 
	 * */
	
	// SPLIT THE variableOnWhichReplacementShouldBePerformed BY THE charactersToBeReplaced
	
	let newSplitCharacterArr = variableOnWhichReplacementShouldBePerformed.split(charactersToBeReplaced);
	
	// COMBINE THE newSplitCharacterArr 
	
	let i = 0;
	
	let newSplitCharacterArrLen = newSplitCharacterArr.length;
	
	let newSplitCharacterArrLenLessOne =  newSplitCharacterArrLen - 1;
	
	let newSplitCharacterArrLenLessTwo =  newSplitCharacterArrLenLessOne - 1;
		
	let newSplitCharacterArrRecombined = "";
	
	for( i = 0; i < newSplitCharacterArrLen; i++){
				
		if( i <  newSplitCharacterArrLenLessOne ){
			
			if( i === newSplitCharacterArrLenLessTwo ){
				
				charactersToBeReplaced = charactersToBeUsedAsReplacement;
			};
			
			newSplitCharacterArrRecombined += newSplitCharacterArr[i]+charactersToBeReplaced;
			
		}else{
			
			newSplitCharacterArrRecombined += newSplitCharacterArr[i];
			
		};
		
		
	};
	
	return newSplitCharacterArrRecombined;
	
	
	
};













